import { render, staticRenderFns } from "./Savings.vue?vue&type=template&id=0d935d76&"
import script from "./Savings.vue?vue&type=script&lang=js&"
export * from "./Savings.vue?vue&type=script&lang=js&"
import style0 from "./Savings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports